import cn from "classnames"
import { useEffect, useRef } from "react"

import { Flex, Text } from "@/atoms"
import { usePrevious } from "@/hooks/usePrevious"
import { PriorityLabel } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/molecules/PriorityLabel"
import { IncidentCard } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/organisms/IncidentCard"

import styles from "./IncidentsColumn.module.scss"

import type { IncidentsColumnProps } from "./IncidentsColumn.types"

export const IncidentsColumn = (props: IncidentsColumnProps) => {
  const { priority, data } = props
  const { list: incidents = [], [priority]: dataByPriority } = data || {}
  const { ids = [], count = ids.length } = dataByPriority || {}
  const isFlash = props.isFlash && !!ids.length
  const lastIndex = useRef(-1)
  const prevIsFlash = usePrevious(isFlash)
  const isFlashToFalse = prevIsFlash && !isFlash

  useEffect(() => {
    if (ids.length && isFlashToFalse) lastIndex.current = ids.length - 1
  }, [ids.length, isFlashToFalse])

  return (
    <Flex vertical className={cn(styles.container, `${priority}-theme`)}>
      <Flex align="center" justify="space-between" className={styles.header}>
        <PriorityLabel priority={priority} />
        <Text type="secondary">{count}</Text>
      </Flex>
      <Flex vertical gap={8}>
        {ids.map((value, index) => {
          const incident = incidents[value]

          if (!incident) return null

          return (
            <IncidentCard
              key={incident.id}
              incident={incident}
              isFlash={isFlash && index > lastIndex.current}
              onOpen={props.onOpenIncident}
            />
          )
        })}
      </Flex>
      {ids.length === 0 && (
        <div className={styles.noIncidents}>No Incidents</div>
      )}
    </Flex>
  )
}
